import React, { PureComponent } from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import AnalyticsTooltip from '../AnalyticsTooltip';

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    const data = payload[0].payload

    return (
      <AnalyticsTooltip
        kicker="Refinance Closure"
        title={data.closeDateLabel}
        rows={[
          { label: "Original Origination", value: data.originalOriginationDate },
          { label: "Original End Date", value: data.originalEndDate },
          { label: "Remaining Term", value: data.remainingTerm },
          { label: "Original Loan Amount", value: `$ ${data.originalPrincipalDue.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}` },
          { label: "Original Rate", value: `${data.originalInterestRate.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} %` },
          { label: "Principal Remaining", value: `$ ${data.remainingPrincipal.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}` },
          { label: "Interest Remaining", value: `$ ${data.remainingInterest.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}` },
          { label: "New Origination", value: data.newOriginationDate },
          { label: "New End Date", value: data.newEndDate },
          { label: "New Loan Amount", value: `$ ${data.newPrincipal.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}` },
          { label: "New Rate", value: `${data.newInterestRate.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} %` },
          { label: "New Interest Due", value: `$ ${data.newInterestDue.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}` },
          { label: "Profit Amount", value: `$ ${data.profitAmount.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}`, emphasis: true },
          { label: "Revenue Increase", value: `${data.profitPercent.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} %` },
          { label: "Team Profit Total", value: `$ ${data.teamTotalProfitAmount.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})}` },
          { label: "Team Revenue Total", value: `${data.teamTotalProfitPercent.toLocaleString("en-US", {maximumFractionDigits: 0, minimumFractionDigits: 0})} %` },
        ]}
      />
    );
  }

  return null;
};

export default class ProfitTrackerChart extends PureComponent {

  render() {
    return (
      <ResponsiveContainer width="100%" height="100%" minHeight={320}>
        <AreaChart
          width={500}
          height={300}
          data={this.props.closures}
          margin={{
            top: 8,
            right: 18,
            left: 18,
            bottom: 6,
          }}
        >
          <defs>
            <linearGradient id="team" x1="0" y1="0" x2="0" y2="1">
              <stop offset="1%" stopColor="#B486BF" stopOpacity={0.1}/>
              <stop offset="95%" stopColor="#000" stopOpacity={0}/>
            </linearGradient>
            <linearGradient id="closure" x1="0" y1="0" x2="0" y2="1">
              <stop offset="1%" stopColor="#00940F" stopOpacity={0.1}/>
              <stop offset="95%" stopColor="#000" stopOpacity={0}/>
            </linearGradient>
          </defs>
          <CartesianGrid strokeDasharray="1 20" stroke="#D4D6DB" />
          <XAxis dataKey="-" tick={{fontSize: 12, fill: "#666C78"}} tickLine={{stroke: "#BDBFC4"}} axisLine={{stroke: "#D4D6DB"}} />
          <YAxis 
            yAxisId='left'
            type='number'
            domain={[0, dataMax => (Math.round((dataMax * 2)/10000)*10000)]}
            tick={{fontSize: 12, fill: "#666C78"}}
            tickLine={{stroke: "#BDBFC4"}}
            axisLine={{stroke: "#D4D6DB"}}
            tickFormatter={tick => {
              return `$${tick.toLocaleString('en-US')}`
            }}
            />
          <YAxis 
            yAxisId='right'
            orientation='right'
            tick={{fontSize: 12, fill: "#666C78"}}
            tickLine={{stroke: "#BDBFC4"}}
            axisLine={{stroke: "#D4D6DB"}}
            tickFormatter={tick => {
              return `$${tick.toLocaleString('en-US')}`
            }}
          />
          <Tooltip 
            content={<CustomTooltip />} 
            wrapperStyle={{outline: "none"}}
          />
          <Legend wrapperStyle={{fontSize: "0.78rem", fontWeight: 700, color: "#666C78", paddingTop: "0.35rem"}} />
          <Area yAxisId='left' type="monotone" dataKey="profitAmount" name="Profit Increase per Closure" stroke="#00940F" fillOpacity={1} fill="url(#closure)" />
          <Area yAxisId='right' type="monotone" dataKey="teamTotalProfitAmount" name="Team Total" stroke="#B486BF" fillOpacity={1} fill="url(#team)" />
        </AreaChart>
      </ResponsiveContainer>
    );
  }
}
